import React from 'react';
import { NEWS_ARTICLE } from '../../lib/queries';
import client from '../../lib/apolloClient';
import Layout from '../../src/components/Layout/Layout';
import Hero from '../../src/components/News/Hero/Hero';
import Body from '../../src/components/News/Body/Body';
import replacePictureUrlWithSignedUrl from '../../src/utils/replaceUrlWithSigned/replaceUrlWithSigned';

const NewsArticle = (props) => {
  const { data } = props;

  return (
    <Layout hero={<Hero data={data.newsArticle} />} whiteTextColor>
      <Body
        data={data}
      />
    </Layout>
  );
};

export default NewsArticle;

export async function getServerSideProps(context) {
  const { pid } = context.query;
  let { data } = await client.query({
    query: NEWS_ARTICLE,
    variables: {
      pid,
    },
  });
  data = await replacePictureUrlWithSignedUrl(data);
  if (data && data.newsArticle) {
    return {
      props: { data },
    };
  }
  return {
    notFound: true,
  };
}
